/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTieredStop.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/tiered-stop";

export class AutogenModelTieredStop<RowType extends ModelRow> extends Endpoint<RowType, RowTieredStopFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTieredStop extends ModelRow<RowTieredStopFields> {
	constructor(values?: Partial<RowTieredStopFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTieredStopFields {
	company_id: string;
	deduct_code: string;
	descr: string;
	id: string;
	is_active: string;
}

